import React from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Navigate } from "react-router-dom";

const AuthLayout = (props) => {
  const token = localStorage.getItem("token");
  const adminData = localStorage.getItem("admin-data");

  // if no token or no admin info -> redirect to login
  if (!token || !adminData) {
    return <Navigate to="/admin-login" replace />;
  }

  let isValidAdmin = false;
  try {
    const admin = JSON.parse(adminData);
    if (admin?._id || admin?.id) {
      isValidAdmin = true;
    }
  } catch (err) {
    console.error("Invalid admin data in localStorage");
    localStorage.clear();
    return <Navigate to="/admin-login" replace />;
  }

  if (!isValidAdmin) {
    return <Navigate to="/admin-login" replace />;
  }

  return (
    <React.Fragment>
      <DashboardLayout>{props.children}</DashboardLayout>
    </React.Fragment>
  );
};

export default AuthLayout;
